export type GrupoPermissao = 'Geral' | 'Menu Dashboard';

export interface PermissaoDef {
  chave: string;
  label: string;
  grupo: GrupoPermissao;
}

export const GRUPOS_PERMISSAO: GrupoPermissao[] = ['Geral', 'Menu Dashboard'];

export const PERMISSOES: PermissaoDef[] = [
  { chave: 'acessa_vendedores',            label: 'Acessar Vendedores',        grupo: 'Geral' },
  { chave: 'acessa_produtos',              label: 'Acessar Produtos',          grupo: 'Geral' },
  { chave: 'acessa_promocoes',             label: 'Acessar Promoções',         grupo: 'Geral' },
  { chave: 'acessa_tabela_especial',       label: 'Acessar Tabela Especial',   grupo: 'Geral' },
  { chave: 'pedidos_analisar',             label: 'Analisar Pedidos',          grupo: 'Geral' },
  { chave: 'pedidos_editar',               label: 'Editar Pedidos',            grupo: 'Geral' },
  { chave: 'pedidos_enviar',               label: 'Enviar Pedidos',            grupo: 'Geral' },
  { chave: 'pedidos_aprovar',              label: 'Aprovar Pedidos',           grupo: 'Geral' },
  { chave: 'dash_bi',                      label: 'Business Intelligence',     grupo: 'Menu Dashboard' },
  { chave: 'dash_contratos',               label: 'Contratos',                 grupo: 'Menu Dashboard' },
  { chave: 'dash_b2b_gestao',              label: 'B2B Gestão',                grupo: 'Menu Dashboard' },
  { chave: 'dash_oportunidades',           label: 'Oportunidades',             grupo: 'Menu Dashboard' },
  { chave: 'dash_resultados',              label: 'Resultados',                grupo: 'Menu Dashboard' },
  { chave: 'dash_liberacoes_financeiro',   label: 'Liberações Automáticas',    grupo: 'Menu Dashboard' },
  { chave: 'dash_uso_promocoes',           label: 'Uso Promoções',             grupo: 'Menu Dashboard' },
  { chave: 'dash_venda_interna',           label: 'Venda Interna',             grupo: 'Menu Dashboard' },
  { chave: 'dash_venda_interna_gerencial', label: 'Venda Interna Gerencial',   grupo: 'Menu Dashboard' },
  { chave: 'dash_venda_interna_whatsapp',  label: 'Venda Interna WhatsApp',    grupo: 'Menu Dashboard' },
  { chave: 'dash_quilometragens',          label: 'Quilometragens e Despesas', grupo: 'Menu Dashboard' },
  { chave: 'dash_vend_externo',            label: 'Vend Externo',              grupo: 'Menu Dashboard' },
];

export function permissoesDoGrupo(grupo: GrupoPermissao): PermissaoDef[] {
  return PERMISSOES.filter(p => p.grupo === grupo);
}

/* Lista de bloqueio carregada no login. Qualquer falha de leitura libera tudo. */
export function permissoesBloqueadas(): string[] {
  try {
    const lista = JSON.parse(localStorage.getItem('permissoes_bloqueadas') || '[]');
    return Array.isArray(lista) ? lista : [];
  } catch {
    return [];
  }
}

export function estaBloqueado(chave: string): boolean {
  return permissoesBloqueadas().includes(chave);
}
